module.exports = "<app-sbutton *ngFor=\"let s of shifts\" (fetchUsers)=\"fetchUsers()\" (refetch)=\"refetch()\" [workplace]=\"workplace\" [date]=\"getDate()\"  [s]=\"s\" [users]=\"users\" [admin]=\"admin\"></app-sbutton>\n<app-sbutton *ngIf=\"shifts.length == 0\" (fetchUsers)=\"fetchUsers()\" (refetch)=\"refetch()\" [workplace]=\"workplace\" [date]=\"getDate()\" [users]=\"users\" [admin]=\"admin\"></app-sbutton>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shift-button/shift-button.component.html
// module id = 465
// module chunks = 1